import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Space, Typography } from '@pitchero/react-ui';
import Card from '../../card';
import { Trans } from '../../../lib/i18n';

const TeamListSection = ({ id, name, teams }) => (
  <>
    <Space bottom="small">
      <Typography preset="tab--active" color="primary" component="h3">
        <Trans i18nKey="common:teams">Teams</Trans>
      </Typography>
    </Space>
    <Space bottom="medium">
      <Typography id={id} preset="title" color="black" component="h4">
        {name}
      </Typography>
    </Space>
    <Grid preset="cards">
      {teams.map((team) => (
        <Card
          key={team.id}
          imageSrc={team.image}
          title={team.name}
          linkProps={{ route: 'team.homepage', params: { teamId: team.id } }}
        />
      ))}
    </Grid>
  </>
);

TeamListSection.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default TeamListSection;
